import GeoMarkIcon from './component'

export default GeoMarkIcon
